<div class="header d-flex justify-content-end border-bottom-sec">
  <!--  <img src="assets/logos/logo-black.png" class="logo" alt="logo"-->
  <!--    routerLink="/home"  >-->
  @if(!user) {
  <div class="d-flex align-items-center gap-2">
    <div class="title">{{ textHeader }}</div>
    <app-button
      [text]="textButton"
      (handleClick)="onClick()"
      [disabled]="false"
    ></app-button>
  </div>
  } @else {
  <div class="profile-menu d-flex align-items-center gap-2">
    <img [src]="displayImg(user.image)" class="user-img" alt="user" />
    <div>
      <div class="name">{{ user.name }}</div>
      <div class="email">{{ user.email }}</div>
    </div>
  </div>
  }
</div>
